import moment from 'moment';

export default {
    computed: {
        driverAge: {
            get() {
                return this.$store.state.search.search.driverAge;
            },
            set(age) {
                this.$store.dispatch('setDriverAge', age);
            },
        },
        promoCode: {
            get() {
                return this.$store.state.search.search.promoCode;
            },
            set(code) {
                this.$store.dispatch('setPromoCode', code);
            },
        },
        pickupDate: {
            get() {
                return this.$store.state.search.search.pickupDate;
            },
            set(date) {
                this.$store.dispatch('setPickupDate', date);
            },
        },
        pickupTime: {
            get() {
                return this.$store.state.search.search.pickupTime;
            },
            set(time) {
                this.$store.dispatch('setPickupTime', time);
            },
        },
        dropoffDate: {
            get() {
                return this.$store.state.search.search.dropoffDate;
            },
            set(date) {
                this.$store.dispatch('setDropoffDate', date);
            },
        },
        dropoffTime: {
            get() {
                return this.$store.state.search.search.dropoffTime;
            },
            set(time) {
                this.$store.dispatch('setDropoffTime', time);
            },
        },
        pickupLocation: {
            get() {
                return this.$store.state.search.search.pickupLocation;
            },
            set(location) {
                this.$store.dispatch('setPickupLocation', location);
            },
        },
        dropoffLocation: {
            get() {
                return this.$store.state.search.search.dropoffLocation;
            },
            set(location) {
                this.$store.dispatch('setDropoffLocation', location);
            },
        },
        dropoffDifferent: {
            get() {
                return this.$store.state.search.search.dropoffDifferent;
            },
            set(different) {
                this.$store.dispatch('setDropoffDifferent', different);
            },
        },
        quoteDates: {
            get() {
                return [moment(this.pickupDate).toISOString(), moment(this.dropoffDate).toISOString()];
            },
            set(dates) {
                if (dates.length === 2) {
                    this.pickupDate = moment(dates[0]).format('YYYY-MM-DD');
                    this.dropoffDate = moment(dates[1]).format('YYYY-MM-DD');
                }
            },
        },
        pickupDateTime() {
            return moment(`${this.pickupDate} ${this.pickupTime}`).toISOString();
        },
        dropoffDateTime() {
            return moment(`${this.dropoffDate} ${this.dropoffTime}`).toISOString();
        },
    },
    methods: {
        toggleDefaultAge() {
            this.driverAge = '';
        },
    },
};
